module.exports = __webpack_public_path__ + "img/groupWhite.d4a49a38.svg";